import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { ChangeTemplateForm } from 'src/routes/Settings/Changes/components/ChangeTemplateForm';
import { useParams } from 'react-router-dom';
import { useChangeTemplate } from 'src/api/queries/changeTemplates/useChangeTemplate';
import { Loader } from 'src/design/atoms/Loader';

export const UpdateChangeTemplate: React.FC = () => {
  const params = useParams<{ id: string }>();
  const { data: template, isLoading } = useChangeTemplate(params.id);

  const templateTitle = isLoading
    ? 'Loading template...'
    : template?.title || params.id;

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Changes', href: '/settings/changes' },
            { text: templateTitle ?? '' },
          ],
        }}
        title={templateTitle ?? ''}
        helpText="Update this change order template's details, labor rates, design rates, and unit pricing."
      />
      {isLoading || !template ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : (
        <ChangeTemplateForm initialValues={template} />
      )}
    </>
  );
};
